import React from 'react';
const kennitala = require('kennitala')
import { Spinner, getPaymentKeyText } from '../../utils'
import { gettext } from '../../locale'
import moment from 'moment'

import ContractLine from '../contract-line'
import 'chartjs-plugin-colorschemes';


class OfferRisleb extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        let customer = this.props.customer
        // let offer = this.props.offers.offers[this.props.customerId][this.props.offerType]

        // let offer = this.props.offers.offers[customer.Customer.AccountNum][this.props.offerType]
        let offer = this.props.offer[this.props.offerType]
        let parameters = offer.parameters
        let keyFigures = offer.keyFigures


        if (offer.isFetching || this.props.customer.isFetching) {
            return <Spinner />
        } else {

            if (offer.error) {
                return (<>
                    { offer.errorMessage }
                </>)
            }

            let kapitalBeiUnfalltod = (parseFloat(keyFigures["GesamteTodesfallleistung"]) * parseFloat(keyFigures.Wert["UZ"])) / 100

            let contractMonths = ""
            if (this.props.infoCollection.RISLEBtype == "insuranceamount") {
                contractMonths = parameters.length * 12
            }

            let paymentTextKey = getPaymentKeyText(this.props.infoCollection["RISLEBpaymentfrequency"])
            

            return (<>
                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>Persónuupplýsingar</h3>
                        {customer.Customer.Name}<br />

                        Dagsetning tilboðs {moment.utc().format("D.M.YYYY")}

                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>Forsendur útreikninga</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>{gettext("startDate")}</strong> ({gettext("startDate", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.start.format("D.M.YYYY")}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{gettext("endDate")}</strong> ({gettext("endDate", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.end.format("D.M.YYYY")}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{gettext("contractLength")}</strong> ({gettext("contractLength", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.length} ár
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">

                        <h3>Lykiltölur</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <tr><td colSpan={2}><b>Bótafjárhæðir</b> (Leistungen aus der Hinterbliebenvorsorge) </td></tr>
                                <ContractLine name="GarantierteTodesfallleistung" value={keyFigures["GarantierteTodesfallleistung"]} currencyExchange={this.props.currencyExchange} />
                                {keyFigures.Betrag["UZ"] && <ContractLine name="kapitalBeiUnfalltod" value={kapitalBeiUnfalltod} extraText={`${parseFloat(keyFigures.Wert["UZ"])}%`}currencyExchange={this.props.currencyExchange} />}
                                <tr><td colSpan={2}><b>{gettext(paymentTextKey)}</b> ({gettext(paymentTextKey, 'de')}) </td></tr>
                                <ContractLine name="LC0" value={keyFigures.Betrag[window.ALLIANZ_TARIFF_NAMES["LC0"]]} currencyExchange={this.props.currencyExchange} eurDecimals={2} />
                                {keyFigures.Betrag["UZ"] && <ContractLine name="UZ" value={keyFigures.Betrag["UZ"]} currencyExchange={this.props.currencyExchange} eurDecimals={2} />}
                                <ContractLine name="Hauptprodukt" value={keyFigures["Hauptprodukt"]} currencyExchange={this.props.currencyExchange} eurDecimals={2} />
                            </tbody>
                        </table>
                    </div>
                </div>

            </>)
        }
    }
}

export default OfferRisleb